module.exports = __webpack_public_path__ + "img/potencia_a.80684aa2.svg";